
/*promokit.youtube({
    el: '.p-sec1__video',
    youtubeid: 'MPMxFN48IoM',
    autoplay: false,
    controls: true
});*/



promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'white' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        cookie: false,
        home: true,
        event: true,
        update: false,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    remote: false
});


// WEBPACK FOOTER //
// ./src/js/throne.js